import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/svg/logo-small-colored.svg'


const _withScopeId = n => (_pushScopeId("data-v-45aef821"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Digital Cards ")
const _hoisted_2 = { class: "navbar-center" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" HOME ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" ABOUT ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" CONTACT ")

import VueScrollTo from 'vue-scrollto'
import { inject, reactive } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {

const scrollTo = VueScrollTo.scrollTo

const data = reactive({
  isTablet: inject('isTablet')
})

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["navbar", {tablet: data.isTablet}]),
    id: "navbar"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["nav-container", {tablet: data.isTablet}])
    }, [
      _createVNode(_component_RouterLink, {
        class: "navbar-center-item--logo",
        to: `/`
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            class: _normalizeClass(["navbar-logo", {tablet: data.isTablet}]),
            src: _imports_0,
            alt: ""
          }, null, 2),
          _createElementVNode("p", {
            class: _normalizeClass(["navbar-title", {tablet: data.isTablet}])
          }, [
            _hoisted_1,
            _createElementVNode("span", {
              class: _normalizeClass(["navbar-title2", {tablet: data.isTablet}])
            }, " Solutions Limited", 2)
          ], 2)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_RouterLink, {
          class: _normalizeClass(["navbar-center-item", {tablet: data.isTablet}]),
          onClickPassive: _cache[0] || (_cache[0] = 
            () => {
              _unref(scrollTo)('#top', 1200, { offset: -300 })
          }),
          to: `/`
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_RouterLink, {
          class: _normalizeClass(["navbar-center-item", {tablet: data.isTablet}]),
          onClickPassive: _cache[1] || (_cache[1] = 
            () => {
              _unref(scrollTo)('#about-us', 1100, { offset: -50 })
          }),
          to: `/`
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_RouterLink, {
          class: _normalizeClass(["navbar-center-item", {tablet: data.isTablet}]),
          onClickPassive: _cache[2] || (_cache[2] = 
            () => {
              _unref(scrollTo)('#contact', 2800, { offset: -550 })
          }),
          to: `/`
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["class"])
      ])
    ], 2)
  ], 2))
}
}

})